module.exports = __webpack_public_path__ + "img/table-itinerary-icon.0b9e0289.svg";